"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectUtils = void 0;
/**
 * Object utilities, but better typed.
 */
var ObjectUtils;
(function (ObjectUtils) {
    function keys(obj) {
        return Object.keys(obj);
    }
    ObjectUtils.keys = keys;
    function entries(obj) {
        return Object.entries(obj);
    }
    ObjectUtils.entries = entries;
    function defineField(obj, key, attr) {
        Object.defineProperty(obj, key, attr);
    }
    ObjectUtils.defineField = defineField;
    function defineAccessor(obj, key, attr) {
        Object.defineProperty(obj, key, attr);
    }
    ObjectUtils.defineAccessor = defineAccessor;
})(ObjectUtils = exports.ObjectUtils || (exports.ObjectUtils = {}));
//# sourceMappingURL=object.js.map